import MicroModal from 'micromodal';

jQuery(function ($) {
    $(document).ready(function() {
        const modal_buttons = $('[data-modal-toggle]');

        // WCAG Event listeners
        modal_buttons.on('keydown', function(e) {
            if (!$(e.target).hasClass('block-agenda-item-clickable')) {
                return;
            }

            switch (e.key) {
                case "Enter":
                case " ":
                    if (e.target)
                    e.preventDefault();
                    MicroModal.show($(this).data('modal-id'));
                    break;
            }
        });

        modal_buttons.on('click', function(e) {
            e.preventDefault();
            MicroModal.show($(this).data('modal-id'));
        });
    });
});